import { useMutation } from "@tanstack/react-query";
import { createAxiosWithAuth } from "./middleware";

export const useAddChat = () => {
  const axios = createAxiosWithAuth();

  return useMutation({
    mutationKey: ["add_chat"],
    mutationFn: async (query) => {
      return await axios.post("/chat/create", query);
    },
  });
};